import { Auth } from '@prismamedia/one-components';

export const auth = new Auth(config.AUTH_API);
